import { render, staticRenderFns } from "./500_KSAT25-30-0300-video-Social_Engineering.vue?vue&type=template&id=5946290e&lang=pug"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports